import api from "./api";

// ---------------- FIELD HARVEST ----------------

// GET ALL (with optional date range)
export const fetchFieldHarvests = async (dateFrom, dateTo) => {
  const params = new URLSearchParams();
  if (dateFrom) params.append("date_from", dateFrom);
  if (dateTo) params.append("date_to", dateTo);
  
  const queryString = params.toString();
  const url = `/field-harvest/field-harvests/${queryString ? `?${queryString}` : ""}`;
  
  const res = await api.get(url);
  return res.data;
};

// CREATE
export const createFieldHarvest = async (data) => {
  const res = await api.post("/field-harvest/field-harvests/", data);
  return res.data;
};

// UPDATE
export const updateFieldHarvest = async (id, data) => {
  const res = await api.put(`/field-harvest/field-harvests/${id}/`, data);
  return res.data;
};

// DELETE
export const deleteFieldHarvest = async (id) => {
  const res = await api.delete(`/field-harvest/field-harvests/${id}/`);
  return res.data;
};